import { createFileRoute } from '@tanstack/react-router'
import { ReactNode } from 'react'

import { useGetInvitation } from '@/gen/publicApi'

import Spinner from '@/components/spinner'

import { useIdentity } from '@/state/identity'

import AcceptForm from './-components/acceptForm'
import InviteError from './-components/inviteError'

const InviteTokenWithCurrentIdentity = () => {
    const { invite_token } = Route.useParams()
    const { identity, fetched } = useIdentity()

    const invite = useGetInvitation(invite_token)

    if (invite.isPending || !fetched) {
        return <Spinner size="md" absolute navVisible={false} />
    }

    if (!invite.data) {
        return <p>No invite found</p>
    }

    const inviteData = invite.data
    const expiryDate = new Date(inviteData.expiresUtc)

    // TODO - something like ts-pattern would make this much cleaner
    let cmp: ReactNode = null
    if (inviteData.tokenState === 'Accepted') {
        cmp = <InviteError title="Already accepted" errorMessage="This invite has already been accepted" />
    } else if (inviteData.tokenState === 'Revoked') {
        cmp = <InviteError title="Revoked invitation" errorMessage="Invite has been revoked" />
    } else if (inviteData.tokenState === 'Expired' || expiryDate < new Date()) {
        cmp = <InviteError title="Expired invitation" errorMessage="Invite expired" />
    } else {
        // console.log(inviteData, identity, identity?.identifier !== inviteData.email)
        const alreadyBelongsToClient = !!identity?.clients.find(c => c.code === inviteData.clientCode)
        if (alreadyBelongsToClient) {
            cmp = <InviteError title="Cannot accept invitation" errorMessage="You're already a member of this client" />
        } else if (identity?.identifier !== inviteData.email) {
            cmp = <InviteError title="Invalid invitation" errorMessage="Invalid invite" />
        }
    }

    if (!cmp) {
        cmp = <AcceptForm invite={inviteData} token={invite_token} />
    }

    return (
        <div className="h-screen overflow-y-hidden">
            <div className="flex h-screen">
                <div className="flex-growp-4">{cmp}</div>
            </div>
        </div>
    )
}

export const Route = createFileRoute('/invite/$invite_token/current/')({
    component: InviteTokenWithCurrentIdentity,
})
